import { useState } from "react";
import { useAppContext } from "../config/AppContext";
import { Org, User } from "../types/basicTypes";
import Icon1 from "../assets/icons/Icon";

interface HomeProps {
  userData: User;
  orgData: Org;
  navigateWorkspace: (path: string) => void;
  setCanFetchFolders: (canFetch: boolean) => void;
  handleClickVariant: (
    message: string,
    variant: "default" | "error" | "success" | "warning" | "info" | undefined
  ) => void;
}

function Home({
  userData,
  orgData,
  navigateWorkspace,
  setCanFetchFolders,
  handleClickVariant,
}: HomeProps) {
  const [tag_open, setTagOpen] = useState(false);
  const { appState, setAppState, fetchCarnets, filter } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const folders_config = appState.folders_config;
  const saved_data = appState.saved_data;
  const [searchValue, setSearchValue] = useState("");

  return (
    <div className="flex flex-col w-full h-full overflow-auto pl-4 pr-6  ">
      <div className="flex flex-col w-full h-fit  gap-4 pb-40">
        <div className="flex flex-row gap-1 justify-between ">
          <div className="text-hx font-medium">Accueil</div>
        </div>
        <div className="flex flex-wrap max-w-c1k gap-4">
          <div
            onClick={() => navigateWorkspace("/ath")}
            className="w-c250 p-2 bg-white shadow-md border cursor-pointer rounded-2xl "
          >
            <div className="flex flex-col  mb-2 p-2">
              <div className="text-h3">Attestations isolants simplifiée</div>{" "}
              <div className="flex flex-row gap-2 items-center">
                <div className="h-2 w-2 rounded-full bg-green-400"></div>{" "}
                <div className="text-h3 text-green-400 font-medium">
                  disponible
                </div>{" "}
              </div>
            </div>
            <img
              src="https://ik.imagekit.io/hexaflow/All%20attestations%20easy%20ath.png?updatedAt=1752335868843"
              className="w-full h-auto rounded-2xl"
            />
          </div>
          <div
            onClick={() => navigateWorkspace("/ath")}
            className="w-c250 p-2 bg-white shadow-md border cursor-pointer  rounded-2xl "
          >
            <div className="flex flex-col  mb-2 p-2">
              <div className="text-h3">Attestations isolants détaillée</div>{" "}
              <div className="flex flex-row gap-2 items-center">
                <div className="h-2 w-2 rounded-full bg-green-400"></div>{" "}
                <div className="text-h3 text-green-400 font-medium">
                  disponible
                </div>{" "}
              </div>
            </div>
            <img
              src="https://ik.imagekit.io/hexaflow/All%20attestations%20easy%20ath%20(1).png?updatedAt=1752335868809"
              className="w-full h-auto rounded-2xl"
            />
          </div>
          <div
            onClick={() => navigateWorkspace("/rtb")}
            className="w-c250 p-2 bg-white shadow-md border cursor-pointer rounded-2xl "
          >
            <div className="flex flex-col  mb-2 p-2">
              <div className="text-h3">Attestations conformité RE2020</div>{" "}
              <div className="flex flex-row gap-2 items-center">
                <div className="h-2 w-2 rounded-full bg-green-400"></div>{" "}
                <div className="text-h3 text-green-400 font-medium">
                  disponible
                </div>{" "}
              </div>
            </div>
            <img
              src="https://ik.imagekit.io/hexaflow/All%20attestations%20easy%20ath%20(2).png?updatedAt=1752335868917"
              className="w-full h-auto rounded-2xl"
            />
          </div>{" "}
          <div
            onClick={() => navigateWorkspace("/rtb")}
            className="w-c250 p-2 bg-white shadow-md border cursor-pointer rounded-2xl "
          >
            <div className="flex flex-col  mb-2 p-2">
              <div className="text-h3">Attestations conformité RT2012</div>{" "}
              <div className="flex flex-row gap-2 items-center">
                <div className="h-2 w-2 rounded-full bg-neutral-400"></div>{" "}
                <div className="text-h3 text-neutral-400 font-medium">
                  bientôt disponible
                </div>{" "}
              </div>
            </div>
            <img
              src="https://ik.imagekit.io/hexaflow/All%20attestations%20easy%20ath%20(2).png?updatedAt=1752335868917"
              className="w-full h-auto rounded-2xl opacity-25"
            />
          </div>{" "}
          <div className="w-c250 p-2 bg-white shadow-md border  rounded-2xl ">
            <div className="flex flex-col  mb-2 p-2">
              <div className="text-h3">Attestations conformité BBIO</div>{" "}
              <div className="flex flex-row gap-2 items-center">
                <div className="h-2 w-2 rounded-full bg-neutral-400"></div>{" "}
                <div className="text-h3 text-neutral-400 font-medium">
                  bientôt disponible
                </div>{" "}
              </div>
            </div>
            <img
              src="https://ik.imagekit.io/hexaflow/All%20attestations%20easy%20ath%20(2).png?updatedAt=1752335868917"
              className="w-full h-auto rounded-2xl opacity-25"
            />
          </div>
        </div>{" "}
      </div>
    </div>
  );
}
export default Home;
